<template>
  <v-bottom-sheet
    v-model="isActive"
    content-class="bg-ui-kit-bg-gray-0 rounded-lg"
  >
    <template #activator="{ props: bottomSheetProps }">
      <v-list-item
        v-bind="bottomSheetProps"
        class="pa-4 pa-md-3"
      >
        <template #prepend>
          <span>Условия использования</span>
        </template>
        <template #append>
          <v-icon
            icon="ui-icon-arrow-right"
            color="ui-kit-icon-secondary"
          />
        </template>
      </v-list-item>
    </template>

    <p class="mx-4 my-4 text-h6">Условия использования</p>

    <TermsOfUseList @navigate="handleNavigate" />
  </v-bottom-sheet>
</template>

<script setup lang="ts">
const isActive = ref(false)
const emit = defineEmits(['navigate'])

function handleNavigate() {
  isActive.value = false
  emit('navigate')
}
</script>
